import axios from 'axios'

// Lấy BASE_URL từ biến môi trường (nếu có) hoặc mặc định http://localhost:8080
export const BASE_URL =  ''

/**
 * Trả về URL đầy đủ kết hợp với BASE_URL
 * @param {string} path - Đường dẫn API (ví dụ: '/api/foods' hoặc '/ws')
 * @returns {string}
 */
export function getApiUrl(path = '') {
  const base = BASE_URL.replace(/\/+$/, '')
  const cleanPath = path.replace(/^\/+/, '')
  return cleanPath ? `${base}/${cleanPath}` : base
}

/**
 * Trả về URL kết nối WebSocket / SockJS dựa theo BASE_URL
 * @param {string} path - Mặc định là '/ws'
 * @returns {string}
 */
export function getWsUrl(path = '/ws') {
  return getApiUrl(path)
}

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default api

